import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InternationalizationService } from './i18n.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [InternationalizationService],
})
export class InternationalizationModule {}
